export default __webpack_public_path__ + "static/media/7b.abdcb9ff.png";